import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-dark pt-12 pb-8 px-6" data-id="element-64">
      <div className="max-w-[1200px] mx-auto flex flex-col items-center" data-id="element-65">
        <h2 className="font-playfair text-[22px] text-white text-center mb-6" data-id="element-66">
          The Hormonal Balance Code
        </h2>

        <nav className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-10 flex-wrap mb-6" data-id="element-67">
          <a href="#/privacy-policy" className="font-lato text-[14px] no-underline hover:underline transition-colors duration-200" style={{
          color: '#E0BBE4',
          cursor: 'pointer'
        }} onMouseEnter={e => {
          ;
          (e.currentTarget as HTMLAnchorElement).style.color = '#FFFFFF';
        }} onMouseLeave={e => {
          ;
          (e.currentTarget as HTMLAnchorElement).style.color = '#E0BBE4';
        }} data-id="element-68">
            Privacy Policy
          </a>
          <a href="#/terms-and-conditions" className="font-lato text-[14px] no-underline hover:underline transition-colors duration-200" style={{
          color: '#E0BBE4',
          cursor: 'pointer'
        }} onMouseEnter={e => {
          ;
          (e.currentTarget as HTMLAnchorElement).style.color = '#FFFFFF';
        }} onMouseLeave={e => {
          ;
          (e.currentTarget as HTMLAnchorElement).style.color = '#E0BBE4';
        }} data-id="element-69">
            Terms and Conditions
          </a>
        </nav>

        <p className="font-lato text-[12px] text-medium max-w-[680px] mx-auto leading-[1.6] text-center mb-4" data-id="element-70">
          Disclaimer: The information provided on this website is educational in
          nature and does not substitute for professional medical advice,
          diagnosis or treatment. Always consult your physician before making
          changes to your health regimen.
        </p>

        <p className="font-lato text-[12px] text-medium text-center m-0" data-id="element-71">
          © 2026 The Hormonal Balance Code. All rights reserved.
        </p>
      </div>
    </footer>;
};